import { render, staticRenderFns } from "./PPHMonitor.vue?vue&type=template&id=5abd7aee&scoped=true"
import script from "./PPHMonitor.vue?vue&type=script&lang=js"
export * from "./PPHMonitor.vue?vue&type=script&lang=js"
import style0 from "./PPHMonitor.vue?vue&type=style&index=0&id=5abd7aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd7aee",
  null
  
)

export default component.exports